import { post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { z } from "zod";

interface SendPlacementAutoInviteParams {
  placementApplicationId: string;
  workplaceId: string;
}

const requestSchema = z.object({
  data: z.object({
    type: z.literal("placement-application"),
    id: z.string(),
  }),
});

export function useSendPlacementAutoInvite(
  options: UseMutationOptions<void, Error, SendPlacementAutoInviteParams> = {}
) {
  return useMutation({
    mutationFn: async (params: SendPlacementAutoInviteParams) => {
      const { placementApplicationId, workplaceId } = params;

      await post({
        url: `${environmentConfig.REACT_APP_API_MAIN_URL}/api/workplaces/${workplaceId}/placement-applications/${placementApplicationId}/interviews/invites`,
        data: {
          data: {
            type: "placement-application",
            id: placementApplicationId,
          },
        },
        responseSchema: z.unknown(),
        requestSchema,
      });
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.PLACEMENT_APPLICATION_AUTO_INVITE_SEND_FAILURE,
      userSuccessMessage: "Your message was sent successfully.",
      userErrorMessage: "Failed to send message",
    },
    ...options,
  });
}
